module.exports = __webpack_public_path__ + "img/balloon-with-hearts.f0d0608.svg";